type DmsSearchResultLike<T> = {
  items: T[];
  nextCursor?: string;
};

/**
 * `dmsSearch` returns `{ items, nextCursor }` after infrastructure FO-4377.
 * Accept the previous `T[]` shape so Fusion can land the unwrap before or
 * after that client change.
 */
export const unwrapDmsSearchResult = <T>(
  result: T[] | DmsSearchResultLike<T>
): DmsSearchResultLike<T> => {
  if (Array.isArray(result)) {
    return { items: result };
  }

  return result;
};
